import { gsap } from 'gsap';
import { animationTrigger } from '../common';

export function initPartnerLogos() {
  const parent = document.querySelector('.js-partner-logos');
  if (!parent) return;

  const cards = [...parent.querySelectorAll('.partner-logos__item')];

  cards.forEach((card, index) => {
    if (!card) return;

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: card,
        start: animationTrigger,
        once: true,
        toggleActions: 'play none none none',
        // markers: true,
      },
    });

    tl.fromTo(
      card,
      { opacity: 0, scale: 0.8, transformOrigin: 'center center' },
      {
        opacity: 1,
        scale: 1.0,
        duration: 0.5,
        ease: 'power1.out',
        delay: index * 0.05,
      },
    );
  });
}
